import { Injectable } from '@angular/core';
import { defer, from, map, Observable, switchMap } from 'rxjs';
import { FeathersService } from './feathers.service';
import { ApiEndpoint, LocalStorageKey } from '../../enums';
import { CertificateDraft } from '../../models/certificate-draft';
import { ApiSearchResponse } from '../../models/api-search-response';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CertificateDraftsService {
  constructor(
    private feathers: FeathersService,
    private http: HttpClient
  ) {}

  createDraft(certificateId: string): Observable<CertificateDraft> {
    return this.feathers.post<CertificateDraft>(ApiEndpoint.CertificateDrafts, {
      certificateId,
    });
  }

  getDrafts(query?: { certificateId?: string }): Observable<ApiSearchResponse<CertificateDraft>> {
    const q = query ? { query } : {};
    return defer(() =>
      from(
        this.feathers.feathers.service(ApiEndpoint.CertificateDrafts).find(q)
      )
    ).pipe(
      map((res: any) => new ApiSearchResponse<CertificateDraft>(res))
    );
  }

  getDraft(draftId: string): Observable<CertificateDraft> {
    return this.feathers.get<CertificateDraft>(
      ApiEndpoint.CertificateDrafts,
      draftId
    );
  }

  approveDraft(draftId: string): Observable<CertificateDraft> {
    return defer(() =>
      from(Promise.resolve(localStorage.getItem(LocalStorageKey.AccessToken)))
    ).pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        });
        return this.http.post<CertificateDraft>(
          `${environment.url}/${ApiEndpoint.CertificateDrafts}/${draftId}/approve`,
          {},
          { headers }
        );
      })
    );
  }

  declineDraft(draftId: string): Observable<CertificateDraft> {
    return defer(() =>
      from(Promise.resolve(localStorage.getItem(LocalStorageKey.AccessToken)))
    ).pipe(
      switchMap((token) => {
        const headers = new HttpHeaders({
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        });
        return this.http.post<CertificateDraft>(
          `${environment.url}/${ApiEndpoint.CertificateDrafts}/${draftId}/decline`,
          {},
          { headers }
        );
      })
    );
  }
}
